import React from 'react';
import axios from 'axios';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import { AuthProvider } from './contexts/AuthContext';

// اعتراض عام لإضافة توكن المصادقة إلى جميع نداءات axios العامة.
// يُسجَّل هنا عند بدء التطبيق ليُضمن تنفيذه دائمًا (الصفحات الكثيرة
// التي تستخدم `axios` مباشرة بدون ترويسة تعتمد على هذا).
axios.interceptors.request.use((config) => {
  const token =
    localStorage.getItem('token') || localStorage.getItem('access_token');
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  const roleId = localStorage.getItem('role_id');
  if (roleId) {
    config.headers = config.headers ?? {};
    config.headers['X-ROLE-ID'] = roleId;
  }
  return config;
});

// Initialize the root using createRoot from react-dom/client
const root = createRoot(document.getElementById('root'));
if (!localStorage.getItem('i18nextLng')) {
  i18n.changeLanguage('en');
}
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <AuthProvider>
        {' '}
        {/* إضافة AuthProvider هنا */}
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
